import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { QuangAuthService } from 'quang/auth'
import { environment } from '../../environments/environment'

export const httpNativeInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(QuangAuthService)
  
  const apiReq = req.clone({
    url: !/^https?:\/\//.test(req.url) && !req.url.includes('assets')
      ? `${environment.domain}${req.url}`
      : `${req.url}`
  })
  
  // Add bearer token to Authorization header if authenticated
  const token = authService.tokenStatus().accessToken
  if (token && !req.url.includes('assets') && !apiReq.headers.has('Authorization')) {
    return next(apiReq.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    }))
  }
  
  return next(apiReq)
}
